import type { HsHypersceneTypes } from '../../math-new/types/hyperscene-types.type';
import type { HsShader } from '../shaders/classes/shader.class';
import { HsDefaultMaterial } from './default-material.class';
import { HsColor } from '../../math-new/objects/color.class';

export class HsTextureMaterial<T extends HsShader> extends HsDefaultMaterial<T> {
  public texture: WebGLTexture | null = null;
  public textureRect: HsHypersceneTypes.Array4 = [0, 0, 1, 1];

  public makeCopy(gl: WebGL2RenderingContext): HsTextureMaterial<T> {
    const material: HsTextureMaterial<T> = new HsTextureMaterial<T>(gl, this.getShader());
    material.texture = this.texture;
    material.textureRect = [...this.textureRect];
    material.color = HsColor.makeCopy(this.color);
    return material;
  }
}
